/**
* @author XuZiYu
* @date 2019/7/8
* @time 17:08
*/
<template>
    <div class="wrapper-submit-order">
        <div class="user-info-model" @click="goAddress">
            <div class="none" v-if="!address.receiverCompleteAddress">+添加收货地址</div>
            <div class="show" v-else>
                <div class="icon-left">
                    <img src="../../assets/public/icon_address_yellow@2x.png" alt=""/>
                </div>
                <div class="info">
                    <div class="user">
                        <span class="name">{{address.receiverName}}</span>
                        <span class="phone">{{address.receiverMobile}}</span>
                    </div>
                    <div class="address">
                        {{address.receiverCompleteAddress}}
                    </div>
                </div>
                <div class="icon-right">
                    <van-icon name="arrow" color="#999999" size="1.7333vw"/>
                </div>
            </div>
        </div>
        <div class="order-info">
            <div class="goods-model">
                <div class="goods-img">
                    <img :src="info.mainImgUrl" alt=""/>
                </div>
                <div class="goods-info">
                    <h2>{{info.name}}</h2>
                    <div class="other-name">
                        {{info.buyData.carModelName}}
                    </div>
                    <div class="goods-price-num">
                        <span><b>¥{{info.buyData.salePrice}}/{{info.buyData.hours}}小时</b></span>
                        <span>*1</span>
                    </div>
                    <div class="remark">
                        {{info.buyData.remark}}
                    </div>
                </div>
            </div>
            <div class="model">
                <span>配送方式</span>
                <span>免运费</span>
            </div>
            <div class="model">
                <span>支付方式</span>
                <span>{{info.selectBuyType === 1 ? '在线支付' : '激活码'}}</span>
            </div>
        </div>
        <div class="footer">
      <span class="money">
        合计 <b>¥{{info.buyData.salePrice}}</b>
      </span>
            <van-button class="btn-submit" @click="submit" :loading="loading">{{info.selectBuyType === 1 ? '提交订单' : '立即激活'}}</van-button>
        </div>
        <ctl-dialog v-model="dialogData" :dialogStyle="dialogStyle" :loading="loading">
            <div slot="content" class="password-input">
                <ul @click="clickInput">
                    <li v-for="v in 6" :key="v">{{value[v - 1]}}</li>
                </ul>
                <input ref="input" type="text" v-model="value" maxlength="6"/>
            </div>
        </ctl-dialog>
        <ctl-dialog v-model="messageDialog" :dialogStyle="dialogStyle" :loading="loading"/>
    </div>
</template>

<script>
import { Icon, Stepper, Button, Toast } from 'vant'
import dialog from '@/components/dialog/index.vue'

export default {
    name: 'submitOrder',
    components: {
        [Icon.name]: Icon,
        [Toast.name]: Toast,
        ctlDialog: dialog,
        [Button.name]: Button,
        [Stepper.name]: Stepper
    },
    data () {
        return {
            value: '',
            dialogStyle: { marginBottom: '' },
            dialogData: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            address: {},
            loading: false,
            info: {},
            goodsInfo: {}
        }
    },
    methods: {
        errorMessage (v) {
            this.messageDialog = {
                visible: true,
                rightBtnName: '确定',
                leftBtnName: '',
                leftBtnMethod: () => {
                },
                rightBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                title: '提示',
                content: v
            }
        },
        // 打开app地址栏
        goAddress () {
            // 跳转班豆任务
            this.$jsBridge.callBackHandler('pushAddressMgPage')
        },
        // 添加地址
        addressCallback (v) {
            let data = JSON.parse(v)
            this.$set(this.address, 'province', data.provinceCode)
            this.$set(this.address, 'city', data.cityCode)
            this.$set(this.address, 'country', data.regionCode)
            this.$set(this.address, 'id', data.id)
            this.$set(this.address, 'receiverAddress', data.address)
            this.$set(this.address, 'receiverMobile', data.phone)
            this.$set(this.address, 'receiverName', data.consignee)
            this.$set(this.address, 'receiverCompleteAddress', data.detailAddress)
        },
        // 获取默认地址
        getDefaultAddress () {
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.getDefaultAddress().then(res => {
                setTimeout(() => {
                    Toast.clear()
                }, 500)
                if (res.status && res.result) {
                    let data = res.result
                    this.$set(this.address, 'id', data.id)
                    this.$set(this.address, 'province', data.province)
                    this.$set(this.address, 'city', data.city)
                    this.$set(this.address, 'addressId', data.id)
                    this.$set(this.address, 'country', data.country)
                    this.$set(this.address, 'receiverAddress', data.receiverAddress)
                    this.$set(this.address, 'receiverMobile', data.receiverMobile)
                    this.$set(this.address, 'receiverName', data.receiverName)
                    this.$set(this.address, 'receiverCompleteAddress', data.receiverCompleteAddress)
                }
            })
        },
        // 点击输入框事件
        clickInput () {
            this.$refs.input.focus()
        },
        // 提交购买订单
        submit () {
            if (!this.address.receiverCompleteAddress) {
                this.errorMessage('请选择地址')
                return
            }

            let data = {
                addressId: this.address.id,
                goodsId: this.info.id,
                goodsNum: 1,
                goodsPriceId: this.info.buyData.id,
                uuid: this.$route.query.id,
                buyType: this.info.selectBuyType
            }

            // 埋点
            this.$jsBridge.callBackHandler('onEventObjectUM', {
                eventId: 'e_ac_order_confirm',
                map: JSON.stringify({
                    goodsId: data.goodsId,
                    goodsPriceId: data.goodsPriceId
                })
            })

            this.loading = true
            this.$api.submitPeijia(data).then(res => {
                this.loading = false

                if (res.status && res.result) {
                    if (this.info.selectBuyType === 5) {
                        this.dialogData = {
                            visible: true,
                            rightBtnName: '立即激活',
                            leftBtnName: '取消',
                            leftBtnMethod: () => {
                                this.$router.replace({
                                    name: 'peijiaOrderDetail',
                                    query: { id: res.result, headShow: '0' }
                                })
                            },
                            rightBtnMethod: () => {
                                if (this.value === '') {
                                    Toast.fail('激活码不能为空')
                                    return
                                }
                                this.loading = true
                                this.$api.activePeijia({
                                    activeCode: this.value,
                                    orderId: res.result
                                }).then(activeRes => {
                                    this.loading = false
                                    if (activeRes.code === '200' && activeRes.status) {
                                        this.$router.replace({
                                            name: 'payResult',
                                            query: {
                                                result: '1',
                                                flag: '1',
                                                headShow: '0',
                                                messageTitle: '激活成功',
                                                id: res.result,
                                                type: '6'
                                            }
                                        })
                                    } else if (activeRes.result) {
                                        Toast.fail(activeRes.result)
                                    } else {
                                        Toast.fail(activeRes.message)
                                    }
                                })
                            },
                            title: '输入6位激活码',
                            content: ''
                        }
                    } else {
                        this.$router.replace({
                            name: 'pay',
                            query: { payId: res.result, money: this.info.buyData.salePrice, type: '6' }
                        })
                    }
                } else {
                    if (res.message === '已售罄') {
                        Toast.fail('商品已售罄')
                        setTimeout(() => {
                            this.$router.back()
                        }, 1000)
                        return
                    }
                    Toast.fail(res.message)
                }
            })
        }
    },
    created () {
        // 暴露添加地址方法
        this.$jsBridge.registerHandler('addressCallback', this.addressCallback)

        this.$set(this, 'info', JSON.parse(JSON.stringify(this.$store.getters.goodsInfo)))
        this.getDefaultAddress()
    }
}
</script>
<style scoped lang="scss">
    .wrapper-submit-order {
        * {
            word-break: break-all;
        }

        /deep/ .van-stepper {
            border: 1px solid #CCCCCC;
            box-sizing: border-box;

            .van-stepper__input {
                margin: 0;
                background: #ffffff;
                font: 400 14px PingFangSC-Regular;
                color: rgba(51, 51, 51, 1);
            }

            .van-stepper__minus {
                border-right: 1px solid #CCCCCC;
                background: #ffffff;

                :before {
                    color: #000000;
                }
            }

            .van-stepper__plus {
                border-left: 1px solid #CCCCCC;
                background: #ffffff;
            }
        }
    }

    .password-input {
        position: relative;
        margin-top: 20px;

        input {
            opacity: 0;
            height: 100px;
            width: 100px;
            border: none;
            position: absolute;
            left: -100%;
        }

        ul {
            justify-content: center;
            display: flex;
            align-items: center;
            text-align: center;

            li {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 40px;
                border: 1px solid #cccccc;
                font: 600 24px PingFangSC;
                color: #333333;

                & + li {
                    border-left: none;
                }
            }
        }
    }

    .footer {
        border-top: 1px solid #eeeeee;
        background: #ffffff;
        height: 49px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;

        .money {
            text-align: center;
            flex: 1;
            font: 400 17px PingFangSC-Regular;
            color: rgba(51, 51, 51, 1);
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;

            b {
                color: #FF5050;
            }
        }

        .btn-submit {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            border: none;
            width: 150px;
            background: rgba(83, 203, 133, 1);
            font: 600 18px PingFangSC-Semibold;
            color: rgba(255, 255, 255, 1);
        }
    }

    .model {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 18px 0;
        border-top: 1px solid #EEEEEE;
        box-sizing: border-box;

        span:nth-child(1) {
            font: 400 14px PingFangSC-Regular;
            color: rgba(102, 102, 102, 1);
        }

        span:nth-child(2) {
            font: 400 14px PingFangSC-Regular;
            color: rgba(51, 51, 51, 1);

            b {
                color: #FF5050;
                margin-left: 5px;
            }
        }
    }

    .num-model {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 18px 0;
        border-top: 1px solid #EEEEEE;
        box-sizing: border-box;

        span:nth-child(1) {
            font: 400 14px PingFangSC-Regular;
            color: rgba(102, 102, 102, 1);
        }
    }

    .order-info {
        background: #ffffff;
        padding: 0 15px;

        .goods-model {
            display: flex;
            align-items: center;
            padding: 15px 0;
            background: #ffffff;

            .goods-img {
                width: 100px;
                height: 100px;
                overflow: hidden;
                display: flex;
                align-items: center;

                img {
                    width: 100px;
                }
            }

            .goods-info {
                line-height: 1;
                margin-left: 15px;
                flex: 1;

                h2 {
                    font: 600 15px PingFangSC-Regular;
                    color: #333333;
                }

                .other-name {
                    display: inline-block;
                    margin: 10px 0 0 0;
                    border-radius: 3px;
                    padding: 1px 10px;
                    border: 1px solid #FF5050;
                    font: 400 12px PingFangSC-Regular, PingFang SC;
                    color: #FF5050;
                }

                .goods-price-num {
                    display: flex;
                    margin-top: 8px;
                    align-items: center;
                    line-height: 1;
                    justify-content: space-between;

                    span {
                        display: inline-block;
                        white-space: nowrap;
                    }

                    span:nth-child(1) {
                        font: 600 14px PingFangSC-Semibold;
                        color: #666666;

                        b {
                            color: #FF5050;
                        }
                    }

                    span:nth-child(2) {
                        font: 400 14px PingFangSC-Regular;
                        color: rgba(51, 51, 51, 1);
                    }
                }
                .remark{
                    line-height: 1;
                    margin: 8px 0 0 0;
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                }
            }
        }
    }

    .wrapper-submit-order {
        background: #FAFAFA;
        height: 100vh;
    }

    .user-info-model {
        background: #ffffff;
        margin-bottom: 10px;
        padding: 15px;

        .none {
            font: 400 14px PingFangSC-Regular;
            color: rgba(83, 203, 133, 1);
            text-align: center;
        }

        .show {
            display: flex;
            align-items: center;
        }

        .icon-left {
            line-height: 1;
            font-size: 0;

            img {
                width: 24px;
            }
        }

        .info {
            flex: 1;
            margin: 0 17px 0 15px;

            .user {
                display: flex;
                align-items: center;

                .name {
                    font: 600 18px PingFangSC-Semibold;
                    color: rgba(51, 51, 51, 1);
                }

                .phone {
                    margin-left: 15px;
                    font: 400 14px PingFangSC-Regular;
                    color: rgba(51, 51, 51, 1);
                }
            }

            .address {
                margin-top: 5px;
                font: 400 14px PingFangSC-Regular;
                color: rgba(51, 51, 51, 1);
                word-break: break-all;
            }

        }
    }
</style>
